import React from 'react';
import { Box, Snackbar, Alert, Grow, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { removeAlertEvent, EventsEntry } from '../../../app/store/slice/events/event';
import { IRootReducer } from '../../../app/store';

interface DialogAlert extends EventsEntry {
    event_id: string;
    type: 'success' | 'info' | 'warning' | 'error';
    message: string;
}

const AlertSnackbar: React.FC<{
    dialog: DialogAlert;
    onClose: (dialog: DialogAlert) => void;
}> = ({ dialog, onClose }) => {
    const { t } = useTranslation();

    return (
        <Snackbar
            key={dialog.event_id}
            open
            autoHideDuration={5000}
            onClose={(_, reason) => {
                if (reason !== 'clickaway') onClose(dialog);
            }}
            TransitionComponent={(props) => (
                <Grow {...props} in timeout={700} />
            )}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert
                severity={dialog.type}
                variant="filled"
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => onClose(dialog)}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                }
            >
                {t(dialog.message)}
            </Alert>
        </Snackbar>
    );
};

const EventHandlerComponent = () => {
    const dispatch = useDispatch();
    const dialogAlerts = useSelector(
        (state: IRootReducer) => state.event.dialogAlerts as DialogAlert[]
    );

    const handleRemoveAlert = (dialog: DialogAlert) => {
        dispatch(removeAlertEvent(dialog));
    };

    return (
        <Box sx={{ position: 'absolute' }}>
            {dialogAlerts.map((dialog) => (
                <AlertSnackbar
                    key={dialog.event_id}
                    dialog={dialog}
                    onClose={handleRemoveAlert}
                />
            ))}
        </Box>
    );
};

export default EventHandlerComponent;